import React, { useState, useEffect, useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { GET_SELECTED_MAIN } from './queries';

import { IPosts, IMain, IPost } from '../../helper/Types';
import { getPostType } from '../../helper/constants';

import { useMediaQuery } from 'react-responsive';
import { toast } from "react-toastify";
import moment from 'moment';
import Slider from 'react-slick';
import { VALoading, VALazyImage } from '../../components';
import { useQueryParams, StringParam } from 'use-query-params';
import Utils from '../../helper/Utils';
import { Link as ScrollLink, Element , Events, animateScroll, scrollSpy, scroller } from 'react-scroll';



function MainContainer() {
    const history = useHistory();
    const [items, setItems] = useState<IPost[]>([]);
    const [images, setImages] = useState(0);

    const [query, setQuery] = useQueryParams({
        index: StringParam,
    });

    const loadData = useQuery<IMain>(GET_SELECTED_MAIN, {
        fetchPolicy: "cache-first"
    });

    useEffect(() => {
        // console.log(images);
        if( images === items.length ) {
            console.log("done");
            const target = `uid-${query.index}`;
            scroller.scrollTo(target, {
                duration: 500,
                delay: 0,
                smooth: true,
                offset: -72
            });
        }

        return() => {
        }
    }, [images]);

    useEffect(() => {
        if( loadData.error ) {
            toast.error(loadData.error.message);
        }

        if( !loadData.loading && !loadData.error ) {
            const loadedData:any = loadData.data?.selectedMain;
            setItems(loadedData);
        }

    }, [loadData]);

    const handleOnLoad = () => {
        setImages(images + 1);
        // console.log(Utils.height());
    }


    let media = (null);
    let settingsMedia = {
        dot: false,
        infinite: false,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        initialSlide: query.index !== undefined ? parseInt(query.index, 10) : 0,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dot: false,
                    arrow: false,
                    rows: 1,
                }
            }
        ],
        afterChange: (_index:number) => {
            setQuery({
                index: _index.toString()
            })
        }
    }

    if( items.length > 0 ) {
        settingsMedia = {
            ...settingsMedia,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        dot: false,
                        arrow: false,
                        rows: items.length,
                    }
                }
            ]
        }

        media = items.map((_item:any, _index:number) => {
            let url = "";
            switch(_item.type) {
                case "project":
                    url = `/project/${_item.uid}`;
                    break;
                case "introduction":
                    url = `/about/introduction/${_item.uid}`;
                    break;
                case "end":
                    url = `/about/essay&drawing/${_item.uid}`;
                    break;
                case "recruit":
                    url = `/recruit`;
                    break;
            }

            const handleBeforeClick = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string, url:string) => {
                setQuery({
                    index: _index
                })

                history.push(url);
            }

            return(
                <Element name={`uid-${_index}`} className="main-item">
                <figure key={_index} className="main-item">
                    <div className="cover">
                        { _item.cover.length > 0 &&
                            <button type="button" onClick={(e) => { handleBeforeClick(e, _index.toString(), url); }}><div className="photo" style={{ backgroundImage: `url('${_item.cover[0].url}')`}}><img src={_item.cover[0].url} alt={_item.title} onLoad={handleOnLoad} /></div></button>
                        }
                    </div>
                    <figcaption className="info">
                        <time dateTime={moment(Number(_item.date)).toString()}>{moment(Number(_item.date)).format("YYYY.MM.DD")}</time>
                        <span className="title"><span className="category">{getPostType(_item)}</span>{_item.title}</span>
                        <Link to={url} className="btn-detail">{_item.type === 'project' ? "Go to project" : "Read More"}</Link>
                    </figcaption>
                </figure>
                </Element>
            );
        });
    }

    return(
        <article id="page-main" className="layout-contents-container page-main">
            <h1 className="hidden">메인</h1>

            { loadData.loading && <VALoading data-size="xlarge" /> }
            { loadData.error && <div>에러가 발생했습니다.</div> }

            <Slider className="list-main" {...settingsMedia}>
                {media}
            </Slider>
        </article>
    );
}

export default MainContainer;

